
(function () {
  'use strict';

  var API = 'https://biblionepal.app/api/store/status';
  var SEEN_API = 'https://biblionepal.app/api/store/seen';
  var CACHE_KEY = 'bn_store_status_v1';
  var SEEN_KEY_PREFIX = 'bn_store_seen_';
  var MAX_TIMEOUT = 2147483000;
  var REVALIDATE_AFTER = 5 * 60 * 1000;
  var SKEW_MIN = 2 * 60 * 1000;

  var ICON_PLUS =
    '<svg aria-hidden="true" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path class="vertical" d="M2.75 7H11.25" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round"/>' +
    '<path class="horizontal" d="M7 2.75L7 11.25" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round"/>' +
    '</svg>';

  var bar = null;
  var panelEl = null;
  var msgEl = null;
  var detailEl = null;
  var boundaryTimer = null;
  var lastFetchAt = 0;
  var stylesReadyPromise = null;
  var renderVersion = 0;

  function bnDir(el) { return getComputedStyle(el || document.documentElement).direction === 'rtl' ? -1 : 1; }
  var skew = 0;

  function realSkew(s) {
    return Math.abs(s) > SKEW_MIN ? s : 0;
  }

  function now() {
    return Date.now() + skew;
  }

  function stylesReady() {
    if (stylesReadyPromise) return stylesReadyPromise;

    var link = document.querySelector('link[data-store-status-styles]');
    if (!link || link.sheet) {
      stylesReadyPromise = Promise.resolve();
      return stylesReadyPromise;
    }

    stylesReadyPromise = new Promise(function (resolve) {
      function done() {
        link.removeEventListener('load', done);
        link.removeEventListener('error', done);
        resolve();
      }
      link.addEventListener('load', done);
      link.addEventListener('error', done);
    });
    return stylesReadyPromise;
  }

  function readCache() {
    try {
      var raw = localStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' ? parsed : null;
    } catch (e) {
      return null;
    }
  }

  function writeCache(payload) {
    try {
      localStorage.setItem(CACHE_KEY, JSON.stringify({ payload: payload, at: Date.now(), skew: skew }));
    } catch (e) {
    }
  }

  function luminance(color) {
    var m = /rgba?\(([^)]+)\)/.exec(color || '');
    if (!m) return null;
    var p = m[1].split(/[\s,\/]+/).filter(Boolean).map(Number);
    if (p.length < 3 || (p.length > 3 && p[3] === 0)) return null;
    return (0.2126 * p[0] + 0.7152 * p[1] + 0.0722 * p[2]) / 255;
  }

  function announcementIsLight() {
    var group = document.getElementById('header-group');
    if (!group) return null;
    var candidates = group.querySelectorAll('.announcement-bar, .section-background');
    for (var i = 0; i < candidates.length; i++) {
      var l = luminance(getComputedStyle(candidates[i]).backgroundColor);
      if (l !== null) return l > 0.5;
    }
    return null;
  }

  function applyContrast() {
    if (!bar) return;
    var light = announcementIsLight();
    if (light === null) return;
    bar.setAttribute('data-contrast', light ? 'on-light' : 'on-dark');
  }

  function build() {
    if (bar) return bar;
    var wrapper = document.querySelector('.page-wrapper');
    var headerGroup = document.getElementById('header-group');
    if (!wrapper || !headerGroup || headerGroup.parentNode !== wrapper) return null;

    bar = document.createElement('aside');
    bar.className = 'bnss';
    bar.setAttribute('data-open', 'false');
    bar.setAttribute('role', 'status');
    bar.setAttribute('aria-live', 'polite');

    panelEl = document.createElement('details');
    panelEl.className = 'bnss__panel';

    var summary = document.createElement('summary');
    summary.className = 'bnss__summary';

    var mark = document.createElement('span');
    mark.className = 'bnss__mark';
    mark.setAttribute('aria-hidden', 'true');

    msgEl = document.createElement('span');
    msgEl.className = 'bnss__msg';

    var plus = document.createElement('span');
    plus.className = 'svg-wrapper icon-plus';
    plus.setAttribute('aria-hidden', 'true');
    plus.innerHTML = ICON_PLUS;

    detailEl = document.createElement('p');
    detailEl.className = 'bnss__detail';

    if (bnDir() === -1) {
      msgEl.dir = 'auto';
      detailEl.dir = 'auto';
    }

    summary.appendChild(mark);
    summary.appendChild(msgEl);
    summary.appendChild(plus);
    panelEl.appendChild(summary);
    panelEl.appendChild(detailEl);
    bar.appendChild(panelEl);
    wrapper.insertBefore(bar, headerGroup);
    applyContrast();
    return bar;
  }

  function hide() {
    if (!bar) return;
    bar.setAttribute('data-open', 'false');
    if (panelEl) panelEl.open = false;
  }

  function reportSeen(id) {
    var key = SEEN_KEY_PREFIX + id;
    try {
      if (sessionStorage.getItem(key)) return;
      sessionStorage.setItem(key, '1');
    } catch (e) {
      return;
    }
    try {
      fetch(SEEN_API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id }),
        keepalive: true,
        mode: 'cors',
      })['catch'](function () {});
    } catch (e) {
    }
  }

  function scheduleBoundary(notice) {
    if (boundaryTimer) {
      clearTimeout(boundaryTimer);
      boundaryTimer = null;
    }
    if (!notice) return;

    var candidates = [];
    var starts = Date.parse(notice.starts_at);
    if (starts > now()) candidates.push(starts);
    if (notice.ends_at) {
      var ends = Date.parse(notice.ends_at);
      if (ends > now()) candidates.push(ends);
    }
    if (!candidates.length) return;

    var next = Math.min.apply(null, candidates);
    var delay = Math.min(next - now() + 1000, MAX_TIMEOUT);
    boundaryTimer = setTimeout(function () {
      load();
    }, Math.max(delay, 0));
  }

  function render(payload) {
    var version = ++renderVersion;
    if (!payload) return;
    var notice = payload.notice;

    if (!notice) {
      hide();
      scheduleBoundary(null);
      return;
    }

    if (Date.parse(notice.starts_at) > now()) {
      hide();
      return;
    }
    if (notice.ends_at && now() >= Date.parse(notice.ends_at)) {
      hide();
      return;
    }

    stylesReady().then(function () {
      if (version !== renderVersion) return;

      if (notice.ends_at && now() >= Date.parse(notice.ends_at)) {
        hide();
        return;
      }

      if (!build()) return;

      msgEl.textContent = notice.message || '';
      detailEl.textContent = notice.detail || '';
      bar.setAttribute('data-open', 'true');

      reportSeen(notice.id);
      scheduleBoundary(notice);
    });
  }

  function load() {
    return fetch(API, { mode: 'cors', credentials: 'omit' })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (payload) {
        if (!payload || !payload.ok) return;
        if (typeof payload.ts === 'number') skew = realSkew(payload.ts - Date.now());
        lastFetchAt = Date.now();
        writeCache(payload);
        render(payload);
      })
      ['catch'](function () {
      });
  }

  function start() {
    var cached = readCache();
    if (cached && cached.payload) {
      if (typeof cached.skew === 'number') skew = realSkew(cached.skew);
      render(cached.payload);
    }
    load();

    window.addEventListener('pageshow', function (event) {
      if (event.persisted) load();
    });

    function revalidate() {
      if (document.visibilityState === 'visible' && Date.now() - lastFetchAt > REVALIDATE_AFTER) {
        load();
      }
    }
    document.addEventListener('visibilitychange', revalidate);
    setInterval(revalidate, 60 * 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
